import React from "react"
import clsx from "clsx"

import { Spinner } from "components"
import classes from "./Button.module.scss"

const Button = props => {
  const {
    variant = "solid",
    className = "",
    color = "primary",
    children,
    loading = false,
    disabled = false,
    onClick = () => { },
    fullWidth = false,
    ...otherProps
  } = props

  return (
    <button
      disabled={disabled}
      onClick={(e) => !loading && onClick(e)}
      className={clsx(className,
        variant === "solid" && classes[`solid-${color}`],
        variant === "outline" && classes[`outline-${color}`],
        variant === "pill" && classes[`pill-${color}`],
        variant === "pill-outline" && classes[`pill-outline-${color}`],
        disabled && classes["disabled"],
        fullWidth && classes["full-width"]
      )}
      {...otherProps}
    >
      {loading ? <Spinner color="white" size={18} /> : children}
    </button>
  )
}

export default Button